export const STATUS = {
    NEW_RELEASE: 'New Release',
    RELEASED: 'Released',
    IN_PROGRESS: 'In Progress',
    PLANNED: 'Planned',
    UNDER_CONSIDERATION: 'Under Consideration',
} as const;

export type StatusType = typeof STATUS[keyof typeof STATUS];
